export interface CompletableProfile {
  firstName: string | null
  lastName: string | null
  nickname: string | null
  avatarUrl: string | null
  phone: string | null
  dateOfBirth: string | null
  gender: string | null
}

export function computeProfileCompletion(p: CompletableProfile): number {
  const fields = [
    p.firstName,
    p.lastName,
    p.nickname,
    p.avatarUrl,
    p.phone,
    p.dateOfBirth,
    p.gender,
  ]
  return Math.round((fields.filter(Boolean).length / fields.length) * 100)
}

export function completionColor(pct: number): 'success' | 'warning' | 'danger' {
  if (pct >= 100) return 'success'
  if (pct >= 50) return 'warning'
  return 'danger'
}
